<template>
  <keep-alive>
    <div class="wrap-simcard-list">
      <div class="wrap-simcard-list_top">

        <div
            :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
            @click="toggleFiltersState"
        >
          <span
              class="mdi"
              :class="filters_state === true ? 'mdi-filter-remove' : 'mdi-filter'"
              @click="toggleFiltersState"
          />
          <span class="main_fiters_toggler_text">
            {{ filters_state ? translate("filter.hide") : translate("filter.show") }}
          </span>
        </div>

        <div class="filter_list">
          <div class="selects" :class="(filters_state === true)? 'shown' : 'hidden'">
            <div class="simcard-list_fiters">
              <tree-select
                  :options="mno_list"
                  :normalizer="normalize_option"
                  :flat="true"
                  :placeholder="translate('simcard_profile.mno')"
                  v-model="filter_simcard_profile.mno"
                  :multiple="true"
                  @input="change_input"
                  name="mno"
              />
            </div>

            <div class="simcard-list_fiters">
              <tree-select
                  :options="status_list"
                  :normalizer="normalize_option"
                  :flat="true"
                  :placeholder="translate('simcard_profile.status')"
                  v-model="filter_simcard_profile.status"
                  :multiple="true"
                  @input="change_input"
              />
            </div>

          </div>

          <div class="selects" :class="(filters_state === true)? 'shown' : 'hidden'">
            <div class="simcard-list_fiters">
              <tree-select
                  :options="tariff_list"
                  :normalizer="normalize_option"
                  :placeholder="translate('simcard_profile.tariff')"
                  v-model="filter_simcard_profile.tariff_id"
                  :multiple="true"
                  @input="change_input"
              />
            </div>

            <div class="simcard-list_fiters">
              <tree-select
                  :options="simcard_apn_list"
                  :normalizer="normalize_option"
                  :flat="true"
                  :placeholder="translate('simcard_profile.simcard_apn')"
                  v-model="filter_simcard_profile.simcard_operator_apn_id"
                  :multiple="true"
                  @input="change_input"
              />
            </div>
          </div>

          <div class="selects" :class="(filters_state === true)? 'shown' : 'hidden'">
            <div class="simcard-list_fiters">
              <fg-input
                  v-model="filter_simcard_profile.msisdn_imsi_iccid"
                  class="name"
                  type="text"
                  placeholder="MSISDN IMSI ICCID"
                  @input="change_input"
                  :clearable="true"
              />
            </div>

            <div class="simcard-list_fiters">
              <tree-select
                  :options="sim_type_list"
                  :normalizer="normalize_option"
                  :flat="true"
                  :placeholder="translate('simcard_profile.sim_type')"
                  v-model="filter_simcard_profile.sim_type"
                  :multiple="true"
                  @input="change_input"
              />
            </div>
          </div>

          <div class="selects" :class="(filters_state === true)? 'shown' : 'hidden'">
            <div class="simcard-list_fiters">
              <fg-input
                  v-model="oper_account"
                  class="name"
                  type="text"
                  :placeholder="translate('simcard_profile.oper_account')"
                  :clearable="true"
              />
            </div>
          </div>
        </div>

        <div class="buttons" :class="(filters_state === true)? 'shown' : 'hidden'">
          <button
              class="btn btn-fill mdi-refresh mdi btn-warning reset-filters-btn mdi-refresh mdi"
              :class="(status_filter())? '' : 'is--no-active'"
              @click.prevent="reset_filter"
          >
            {{ translate('filter.reset') }}
          </button>
        </div>
      </div>

      <div class="response_table">
        <div v-if="load" class="loader">
          <scale-loader />
        </div>
        <table>
          <thead
            ref="tableHead"
            class="table-simcard-list_bg"
            :class="(filters_state)? 'simcard-list_fiters_is--show' : 'simcard-list_fiters_is--hidden'"
          >
            <tr>
              <th scope="col" style="width: 100px">
                {{ translate('simcard_profile.status') }}
              </th>

              <th scope="col" class="table-simcard-list_mob-filters w5per">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.mno')}}
                </span>
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                    v-model="filter_simcard_profile.oper_account"
                    :label="translate('simcard_profile.oper_account')"
                    @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_profile.msisdn"
                  :label="translate('simcard_profile.msisdn')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_profile.imsi"
                  :label="translate('simcard_profile.imsi')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters w10per">
                <tag-list-popup
                  v-model="filter_simcard_profile.iccid"
                  :label="translate('simcard_profile.iccid')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters"  style="width: 300px">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.tariff')}}
                </span>
              </th>

              <th scope="col" style="width: 160px">
                {{ translate('tariffication.device') }}
              </th>

              <th scope="col" class="table-simcard-list_mob-filters w70">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.type_short')}}
                </span>
              </th>

              <th scope="col" class="table-simcard-list_mob-filters"  style="width: 120px">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.apn_short')}}
                </span>
              </th>

              <th scope="col" class="table-simcard-list_mob-filters"  style="width: 120px">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.status')}}
                </span>
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <span class="tag-list-popup_title_text">
                  {{translate('simcard_profile.ts_update')}}
                </span>
              </th>

              <th style="width: 7px" />
            </tr>
          </thead>
          <tbody ref="tableSimcard" style="position: relative" @scroll.passive="paint_chart($event)">
            <SimCardProfileListItem
              v-for="(item,index) in trs"
              class="simcard_item"
              ref="mySimcard"
              :key="index"
              :index="index"
              :item="item"
              :traffic_list="traffic_simcard_profile"
              @check="resetCheck"
            />
            <tr v-if="afterload" style="border:none; background-color:  transparent;" >
              <td> <scale-loader /> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>

import SimCardProfileListItem from './Item/Index.vue'
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'

export default {
  name: 'SimCardProfileList',
  components: {
    SimCardProfileListItem,
    TagListPopup
  },
  data () {
    return {
      load: true,
      top: 0,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: '',
      pages: 0,
      rendList: [],
      resizeList: [],
      checkall: false,
      was_checkall: false,
      uncheckList: {},
      filter_simcard_profile: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      date: [],
      traffic_simcard_profile: {},
      mno_list: [],
      tariff_list: [],
      sim_type_list: [],
      oper_account: ""
    }
  },
  computed: {
    status_list(){
      return [
        { id: -1, label: this.translate('status_info.undefined') },
        { id: 1, label: this.translate('status_info.active') },
        { id: 2, label: this.translate('status_info.blocked') },
        { id: 3, label: this.translate('status_info.prepare') },
        { id: 4, label: this.translate('status_info.stop') },
      ]
    },
    simcard_apn_list(){
      return this.$store.getters.getSimcardOperatorApn.map((apn) => {
        return { id: apn.id, label: apn.name }
      })
    }
  },

  watch: {
    '$route.query'(){
      if (this.$route.params.simcard_profile_list_section === 'sim_card_list') {
        this.check_query(true)
        this.change_input()
      }
    },
    oper_account(new_val, old_val){
      const list = this.filter_simcard_profile.oper_account
      const index = list.indexOf(old_val)

      if (index !== -1) {
        list.splice(index, 1)
      }

      if (new_val) list.push(new_val)
      this.change_input()
    },

    tableData () {
      let trs = Object.keys(this.tableData).map((index) => {
        return {...this.tableData[index], checked: this.was_checkall}
      })

      if (trs.length === 0) {
        this.trs = []
      } else {
        this.$set(this, 'trs', trs)
      }

      this.load = false
      this.afterload = false
      this.$nextTick(this.mountItem)
      return true
    },
    filter_simcard_profile: {
      deep: true,
      handler() {
        if (this.$route.params.simcard_profile_list_section !== 'sim_card_list') return
        let query = {...this.$route.query}
        for (let key in this.filter_simcard_profile) {
          switch (key) {
            case 'tariff_id':
            case 'mno':
            case "status":
            case "sim_type":
            case "simcard_operator_apn_id":
              if (this.filter_simcard_profile[key].length > 0){
                query[key] = this.filter_simcard_profile[key].join(',')
              } else {
                delete query[key]
              }
              break
            case "msisdn_imsi_iccid":
              if (this.filter_simcard_profile[key] !== ""){
                query[key] = this.filter_simcard_profile[key]
              } else {
                delete query[key]
              }
              break
          }
        }

        this.localStorage.setItem('filter_simcard_profile', JSON.stringify(this.filter_simcard_profile))
        const location = {path: this.$route.path, query}
        if (this.$router.resolve(location).route.fullPath !== this.$route.fullPath) {
          this.$router.replace(location)
        }
      },
    },
    "filter_simcard_profile.msisdn_imsi_iccid":{
      handler(){
        this.filter_simcard_profile.msisdn_imsi_iccid = this.filter_simcard_profile.msisdn_imsi_iccid.replace(" ", "")
      }
    }
  },
  created () {
    this.init()
    window.addEventListener('resize', this.handleResize)
  },
  activated () {
    this.init();
    this.$refs.tableSimcard.scrollTop = this.top
    if (this.$store.getters.getSimcardProfileListChange) {
      this.$store.commit('setSimcardProfileListChange', false)
    }
    clearInterval(this.interval_update)
    this.change_input()

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  deactivated () {
    clearInterval(this.interval_update)
    this.top = this.$refs.tableSimcard.scrollTop
    window.removeEventListener('resize', this.handleResize)
    this.ids = []
    this.tableData = []
  },

  methods: {
    normalize_option(node){
      return {id: String(node.id)}
    },
    check_query(reset = false) {
      if (reset) {
        for (let key of ['mno', 'tariff_id', 'status', 'sim_type', 'simcard_operator_apn_id']) {
          if (this.$route.query[key] === undefined) this.filter_simcard_profile[key] = []
        }
        if (this.$route.query.msisdn_imsi_iccid === undefined) this.filter_simcard_profile.msisdn_imsi_iccid = ""
      }
      if (Object.keys(this.$route.query).length > 0) {
        for (let key in this.$route.query) {
          switch (key) {
            case "mno":
            case "tariff_id":
            case "status":
            case "sim_type":
            case "simcard_operator_apn_id":
              this.filter_simcard_profile[key] = String(this.$route.query[key]).split(',').filter(item => item !== '')
              break;
            case "msisdn_imsi_iccid":
              if (this.$route.query[key] !== ""){
                this.filter_simcard_profile[key] = this.$route.query[key]
              }
              break;
          }
        }
      }
    },
    get_simcard () {
      this.ids = []
      this.load = true

      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getSimcardProfileListUpdate)
      this.rendList = []

      let filter_simcard_profile = Object.assign({}, this.filter_simcard_profile)
      if (filter_simcard_profile.simcard_operator_apn_id.length < 1) delete filter_simcard_profile.simcard_operator_apn_id

      this.$store.dispatch('setSimcardProfileFilter', filter_simcard_profile)
      this.localStorage.setItem('filter_simcard_profile', JSON.stringify(filter_simcard_profile))

      this.$http.simcard.getPagesSimcards(filter_simcard_profile, (response) => {
        this.pages = response.data.pages
        this.traffic_simcard_profile = response.data.tariff_list
        this.mno_list = response.data.mno_list
        this.sim_type_list = response.data.sim_type

        let list = []
        for (let index in this.traffic_simcard_profile) {
          if (this.traffic_simcard_profile[index].tariff_name !== '' && this.traffic_simcard_profile[index].tariff_name !== '-') {
            list.push({id: this.traffic_simcard_profile[index].id, label: '(' + this.traffic_simcard_profile[index].mno.toLowerCase() + ') ' + this.traffic_simcard_profile[index].tariff_name})
          }
        }
        this.tariff_list = list.sort((a, b) => a.label > b.label ? -1 : 1)

        for (let group_id in response.data.group) {
          this.group_cnt[group_id] = response.data.group[group_id]
        }

        this.hash = response.data.hash
        this.$http.simcard.getSimcardList({...filter_simcard_profile, 'page': this.cur_page = 0}, (response) => {
          this.tableData = {...response.data.sim}
          this.ids = [...response.data.ids]
        })
      })
    },
    update_status () {
      this.date = new Date()
      this.$http.simcard.getPagesSimcards(this.filter_simcard_profile, (response) => {
        this.page = response.data.pages
        this.group = response.data.group
        this.traffic_simcard_profile = response.data.tariff_list
        this.mno_list = response.data.mno_list
        this.sim_type_list = response.data.sim_type

        let list = []
        for (let index in this.traffic_simcard_profile) {
          if (this.traffic_simcard_profile[index].tariff_name !== '' && this.traffic_simcard_profile[index].tariff_name !== '-') {
            list.push({id: this.traffic_simcard_profile[index].id, label: '(' + this.traffic_simcard_profile[index].mno.toLowerCase() + ') ' + this.traffic_simcard_profile[index].tariff_name})
          }
        }
        this.tariff_list = list.sort((a, b) => a.label > b.label ? -1 : 1)

        for (let i = 0; i <= this.cur_page; i++) {
          setTimeout(() => {
            this.$http.simcard.getSimcardList({...this.filter_simcard_profile, 'page': i}, (response) => {
              for (let i in response.data.sim) {
                if (this.tableData[i] === undefined) {
                  this.tableData[i] = {}
                }
                this.tableData[i] = response.data.sim[i]
              }
            })
          }, 300)
        }
      })
    },
    change_group () {
      this.change_input()
    },
    change_status (name, value) {
      this.filter_simcard_profile.status[name] = value
      this.change_input()
    },

    handleResize () {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res)
      }
      this.timer_res = setTimeout(() => { this.resizeList = [...this.$refs.mySimcard]; this.paint_chart() }, 300)
    },
    checkAll () {
      this.checkall = !this.checkall
      this.was_checkall = this.checkall
      this.tableData = {...this.tableData}
      this.uncheckList = {}
    },
    resetCheck (check, dev_id) {
      if(this.checkall) {
        this.was_checkall = true
      }
      if(this.was_checkall && !check && this.uncheckList[dev_id] === undefined) {
        this.uncheckList[dev_id] = 1
      } else {
        delete this.uncheckList[dev_id]
      }
      this.checkall = false
    },
    status_filter () {
      for (let i in this.filter_simcard_profile) {
        if (i === 'status') {
          for (let j in this.filter_simcard_profile.status) {
            if (this.filter_simcard_profile.status[j]) {
              return true
            }
          }
        } else {
          if (this.filter_simcard_profile[i].length > 0) {
            return true
          }
        }
      }
      return false
    },
    get_filter () {
      let arr = {
        mno: [],
        msisdn:[],
        iccid: [],
        imsi:[],
        status: [],
        sim_type: [],
        tariff_id: [],
        oper_account: [],
        msisdn_imsi_iccid: "",
        simcard_operator_apn_id: []
      }
      let res = {}

      let filter_simcard_profile = JSON.parse(this.localStorage.getItem('filter_simcard_profile'))

      if (filter_simcard_profile !== null) {
        for (var i in arr) {
          if (filter_simcard_profile[i] !== undefined) {
            res[i] = filter_simcard_profile[i]
          } else {
            res[i] = arr[i]
          }
        }
      } else {
        res = arr
      }
      for (let key of ['mno', 'tariff_id', 'status', 'sim_type', 'simcard_operator_apn_id']) {
        res[key] = res[key].map(String)
      }
      return res
    },

    init () {
      this.filter_simcard_profile = this.get_filter()
      this.check_query()
      this.date = new Date()
    },

    paint_chart () {
      let tmpRend = []
      let table = this.$refs.tableSimcard
      for (let i in this.resizeList) {
        if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) && this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize
          }
        } else {
          tmpRend.push(this.resizeList[i])
        }
      }

      if (tmpRend.length > 0) {
        this.resizeList = [...tmpRend]
      }

      tmpRend = []
      for (let i in this.rendList) {
        if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) && this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          this.rendList[i].chartStatus = true
        } else {
          tmpRend.push(this.rendList[i])
        }
      }
      this.rendList = tmpRend
      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
        if (this.cur_page < this.pages) {
          this.add_simcard_in_list()
        }
      }
    },

    mountItem () {
      if (this.trs.length === 0) {
        return false
      }
      let length = (this.$refs.mySimcard.length < 25) ? this.$refs.mySimcard.length : 25

      if (length < this.$refs.mySimcard.length) {
        for (let i = 25; i < this.$refs.mySimcard.length; i++) {
          this.rendList.push(this.$refs.mySimcard[i])
        }
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_simcard, 1000)
    },

    reset_filter () {
      this.oper_account = ""
      this.filter_simcard_profile = {
        mno: [],
        msisdn:[],
        iccid: [],
        imsi:[],
        status: [],
        sim_type: [],
        tariff_id: [],
        oper_account: [],
        msisdn_imsi_iccid: "",
        simcard_operator_apn_id: []
      }
      this.change_input()
    },

    add_simcard_in_list () {
      if (this.cur_page+1 < this.pages) {
        this.afterload = true
        this.$http.simcard.getSimcardList({...this.filter_simcard_profile, 'page': ++this.cur_page}, (response) => {
          let tmp = {...this.tableData}
          for (let i in response.data.sim) {
            if (tmp[i] === undefined) {
              tmp[i] = {}
            }
            tmp[i] = response.data.sim[i]
          }
          this.tableData = {...tmp}
          this.ids = [...this.ids, ...response.data.ids]
        })
      }
    },

    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>

.wrap-simcard-list{
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table{
    padding: 0;
    ::v-deep th,
    ::v-deep td{
      font-size: 12px;
      vertical-align: middle;
    }
    ::v-deep th *:not(.mdi),
    ::v-deep td *:not(.mdi){
      font-size: 12px;
    }
    .simcard_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
      }
    }
  }
  &_top {
    padding: 30px 1vh 1vh;
    background: #FFF;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dddddd;
    border-bottom: none;

    .filter_list{
      width: 90%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .selects{
        width: 100%;
        margin-right: 10px;
        .simcard-list_fiters{
          margin-bottom: 10px;
        }
      }
    }
    .buttons{
      width: 10%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .btn{
        padding: 0 10px;
      }
    }
    .reset-filters-wrap{
      width: 10%;
      .reset-filters-btn{
        width: 100%;
      }
      &--hidden{
        display: none;
      }
    }

    .simcard-list_fiters_toggler {
      position: absolute;
      right: 50%;
      top: -3px;
      margin: -2rem -6.5rem auto auto;
      font-size: 1.15rem;
      line-height: 2rem;
      width: 13rem;
      height: 2.25rem;
      color: #66615b;
      cursor: pointer;
      z-index: 20;
      background: #FFF !important;
      text-align: center;
      border-radius: 5px 5px 0 0;
      border: 1px solid #ddd;
      border-bottom: none;
      &_text{
        color: #66615b;
        border-bottom: 1px dashed #ccc;
        margin-top: -1px;
        line-height: 1.12rem;
        display: inline-block;
        vertical-align: middle;
      }
      &.active{
        span{
          color: #ccc;
        }
      }
    }
    .simcard-list_fiters_is {
      width: 40%;
      transition: all ease 0.15s, opacity ease 0.25s;
      &.show{
        opacity: 1;
      }
      &.hidden{
        opacity: 0;
      }
      .form-group{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        .manage_btn{
          margin-left: 0;
        }
      }
    }
  }
}
.table-simcard-list_mob-filters__traffic{
  font-size: 0.95rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  cursor: pointer;
  .mdi{
    transition: 0.2s;
    &::before{
      transform: rotate(180deg);
    }
    &.reverse::before{
      transform: rotate(0);
    }
  }
}

</style>
